import { combineReducers } from 'redux';
import abExperiments from '@nykaa/experiment-sdk/store/reducer';
import auth from 'store/auth/reducer';
import app from 'store/app/reducer';
import remoteConfig from 'store/remoteConfig/reducer';

import mobileVerification from './mobileVerification/reducer';
import emailVerification from './emailVerification/reducer';
import userPortfolio from './userPortfolio/reducer';
import resetPassword from './resetPassword/reducer';
import accountMerging from './accountMerging/reducer';

const createRootReducer = () =>
  combineReducers({
    appReducer: app,
    auth,
    mobileVerification,
    remoteConfig,
    userPortfolio,
    resetPassword,
    emailVerification,
    accountMerging,
    abExperiments,
  });

export default createRootReducer;
